export const SET_INSTITUICAO = 'SET_INSTITUICAO'
export const OPEN_INSTITUICAO = 'OPEN_INSTITUICAO'
export const CLOSE_INSTITUICAO = 'CLOSE_INSTITUICAO'